import { hashRouteTemplate } from "./routesConfig";

const R_SPLIT = /[,&]/;
const R_HASH = /#.*|$/;
const HASH = '#';
const SEPARATOR_COMMA = ',';
const EMPTY = '';

const numericValueList = ['game', 'gamepk', 'detail'];
const keyPairMap = {
    detail: 'detail',
    lang: 'lang',
    locale: 'locale',
    game_state: 'game_state',
    game_tab: 'game_tab',
    game: 'game',
    gamepk: 'game',
    view: 'game_state',
    tab: 'game_tab',
    tfs: 'timecode',
    game_detail: 'detail',
    id: 'id',
    themeMode: 'themeMode',
    isStickyScore: 'isStickyScore'
};

const pushMap = {
    gamePk: 'game',
    game_view: 'game_state',
    timecode: 'tfs',
    game_tab: 'game_tab',
    detail: 'game_detail',
    language: 'lang'
};

const viewtabMap = {
    plays: 'summary',
    video: 'video',
    videos: 'video',
    color: 'summary',
    'play-by-play': 'summary'
};

const detailMap = {
    video: 'highlights',
    videos: 'highlights'
};

const hashParams = (hash) => {
    const newMap = {};
    const pairs = (hash ?? window?.location?.hash).replace(HASH, EMPTY).split(R_SPLIT) || [];
    pairs.forEach(pair => {
        let [key, value] = pair.split('=');
        if (key in keyPairMap) {
            if (keyPairMap?.[key]) {
                if (key === 'game_tab') {
                    value = viewtabMap[value] || value;
                }

                if (numericValueList.includes(key)) {
                    value = value * 1;
                }

                if (key === 'game_detail') {
                    if (detailMap[value]) {
                        value = detailMap[value];
                    }
                }

                newMap[keyPairMap?.[key]] = value;
            }
        }
    });

    return newMap;
};

const pushHashParams = (params = {}, separator = SEPARATOR_COMMA) => {
    const {
        views,
        gumbo: {
            gameData: {
                game: {
                    pk
                } = {},
            } = {}
        } = {}
    } = params;
    const hashSource = { ...views, gamePk: pk };
    const newHash = hashRouteTemplate.map(key => {
        if (hashSource[key]) {
            return `${pushMap[key] || key}=${hashSource[key]}`;
        }
        return false;
    }).filter(Boolean).join(separator);

    if (window?.location && newHash) {
        const { href, hash: currentHash } = window.location;
        const newHashFragment = HASH + newHash;

        if (newHashFragment !== currentHash && href) {
            // Lets do it old school, no history biz.
            window.location.replace(
                href.replace(R_HASH, newHashFragment)
            );
        }
    }
    return newHash;
};

export default hashParams;
export { pushHashParams };
